import { useEffect, useState } from "react";
import Accordion from "./accordion"
import { PropTypes } from 'prop-types';
import RoomDetail from "./roomDetail";
import { useDispatch, useSelector } from "react-redux";
import { fetchCampusLifeAccommodationData } from "../../redux/slice/campusLifeAccommodation";
import { DecodeHtml } from "../../utils/decodeHtml";
import { retrunAssets } from "../../utils/getAssets";
import axios from "axios";
import { apis } from "../../api/apiUrl";


const DetailRooms = ({ data }) => {



    const [roomsData, setRoomsData] = useState([])

    useEffect(() => {

        axios.get(`${apis.umbraco_delivery_api}/${data.path}`).then(
            response => {
                setRoomsData(response.data)
            }
        )



    }, [data.path])


    // const dispatch = useDispatch()
    // useEffect(() => {
    //     console.log(path)
    //     dispatch(fetchCampusLifeAccommodationData(path))
    // }, [path])


    const description =  roomsData?.properties?.details?.markup 
    const rooms = roomsData?.properties?.rooms?.items?.map(item => {
        let room = item?.content?.properties
        return (
            {
                label: room?.label,
                images: room?.images?.map(item1 => retrunAssets(item1?.url)),
                noOfStudentRoom: room?.noOfStudentRoom,
                noOfStudentApartment: room?.noOfStudentApartment,
                advancePayment: room?.advancePayment,
                rentalMonth: room?.rentalMonth,
                rentalInformationBrochureDownload: room?.rentalInformationBrochureDownload !== null ? retrunAssets(room?.rentalInformationBrochureDownload[0].url) : null,
            }
        )
    })
    const [accordion, setAccordion] = useState([])
    useEffect(() => {
        setAccordion(
            rooms?.map((item, index) => ({
                question: item?.label,
                answer:
                    <RoomDetail
                        images={item?.images}
                        noOfStudentRoom={item?.noOfStudentRoom}
                        noOfStudentApartment={item?.noOfStudentApartment}
                        advancePayment={item?.advancePayment}
                        rentalMonth={item?.rentalMonth}
                        rentalInformationBrochureDownload={item?.rentalInformationBrochureDownload}
                    />,
                open: index === 0
            })
            )
        )
    }, [roomsData])




    return (
        <div className="flex flex-col gap-3">
            <h1 className="w-auto  text-slate-900 text-3xl sm:text-5xl leading-[3rem] font-bold capitalize">Accommodation Details</h1>
            <p className="w-auto   text-neutral-800 text-base font-normal leading-relaxed">{
                DecodeHtml({ html: description })
            }</p>
            <h1 className="text-slate-900 text-2xl sm:text-4xl font-bold">Rooms </h1>
            {
                rooms &&
                <Accordion accordion={accordion} setAccordion={setAccordion} />}
        </div>
    )
}
DetailRooms.propTypes = {
    data: PropTypes.any

}
export default DetailRooms